function TextOptions() {
  const options = []

  return options
}

export default TextOptions
